import React from 'react';
import PropTypes from 'prop-types';
import { TextInput, Checkbox } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import IconInfoCircle from '../../components/icons/IconInfoCircle';
import IcDate from '../../components/icons/IcDate';
import styles from './styles.scoped.css';

function FormLabel({ required, text }) {
  return (
    <label className={styles.formLabel}>
      {text} {required && <span className={styles.requiredAsterisk}>*</span>}
    </label>
  );
}

FormLabel.propTypes = {
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default function FormFieldsSubsidi({
  RpPrefix,
  endDate,
  handleClose,
  handleNilaiChange,
  handleStartDateChange,
  handleSubmit,
  isConfirmed,
  isFormValid,
  isLoading,
  isStartDateDisabled,
  maxEndDate,
  maxStartDate,
  minEndDate,
  minStartDate,
  nilai,
  nilaiError,
  setEndDate,
  setIsConfirmed,
  startDate,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.formGroup}>
        <FormLabel required text="Nilai Besaran Subsidi" />
        <TextInput
          error={nilaiError}
          leftSection={RpPrefix}
          onChange={handleNilaiChange}
          radius="md"
          size="md"
          value={nilai}
        />
      </div>

      <div className={styles.dateRangeGrid}>
        <div className={styles.formGroup}>
          <FormLabel required text="Tanggal Mulai Subsidi" />
          <DateInput
            clearable={!isStartDateDisabled}
            disabled={isStartDateDisabled}
            leftSection={<IcDate fill={isStartDateDisabled ? '#A0A0A0' : '#212121'} />}
            maxDate={maxStartDate}
            minDate={minStartDate}
            onChange={handleStartDateChange}
            placeholder="DD/MM/YYYY"
            radius="md"
            rightSection={<IcDate fill={isStartDateDisabled ? '#A0A0A0' : '#212121'} />}
            size="md"
            value={startDate}
            valueFormat="DD/MM/YYYY"
          />
        </div>

        <div className={styles.formGroup}>
          <FormLabel required text="Tanggal Berakhir Subsidi" />
          <DateInput
            clearable
            leftSection={<IcDate fill="#212121" />}
            maxDate={maxEndDate}
            minDate={minEndDate}
            onChange={setEndDate}
            placeholder="DD/MM/YYYY"
            radius="md"
            rightSection={<IcDate fill="#212121" />}
            size="md"
            value={endDate}
            valueFormat="DD/MM/YYYY"
          />
        </div>
      </div>

      {isStartDateDisabled && (
        <div className={styles.dateHelperText}>
          <IconInfoCircle />
          <span>
            Periode baru menggantikan periode aktif dan harus berakhir sebelum
            jadwal berikutnya dimulai.
          </span>
        </div>
      )}

      <div style={{ marginBottom: '24px', marginTop: '20px' }}>
        <Checkbox
          checked={isConfirmed}
          color="#5E811E"
          label="Saya yakin untuk menambahkan informasi besaran subsidi baru."
          onChange={(e) => setIsConfirmed(e.currentTarget.checked)}
          styles={{
            input: {
              '&:checked': {
                backgroundColor: '#5E811E',
                borderColor: '#5E811E',
              },
            },
            label: {
              fontWeight: 400,
            },
          }}
        />
      </div>

      <div className={styles.modalFooter}>
        <button
          className={styles.btnOutlineGreen}
          onClick={handleClose}
          style={{ borderRadius: '8px', flex: 1, padding: '10px 24px' }}
          type="button"
        >
          Batal
        </button>
        <button
          className={styles.btnPrimaryGreen}
          disabled={!isFormValid || isLoading}
          style={{ borderRadius: '8px', flex: 1, padding: '10px 24px' }}
          type="submit"
        >
          {isLoading ? 'Menyimpan...' : 'Tambah Informasi Besaran Subsidi'}
        </button>
      </div>
    </form>
  );
}

const datePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]);

FormFieldsSubsidi.propTypes = {
  endDate: datePropType,
  handleClose: PropTypes.func.isRequired,
  handleNilaiChange: PropTypes.func.isRequired,
  handleStartDateChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isConfirmed: PropTypes.bool.isRequired,
  isFormValid: PropTypes.bool,
  isLoading: PropTypes.bool,
  isStartDateDisabled: PropTypes.bool,
  maxEndDate: datePropType,
  maxStartDate: datePropType,
  minEndDate: datePropType,
  minStartDate: datePropType,
  nilai: PropTypes.string.isRequired,
  nilaiError: PropTypes.string,
  RpPrefix: PropTypes.node,
  setEndDate: PropTypes.func.isRequired,
  setIsConfirmed: PropTypes.func.isRequired,
  startDate: datePropType,
};
